/**
 * Check Valid Phone Number
 * @param {String} phoneNumber
 * @return {String}
*/
const checkValidPhoneNumber = (phoneNumber) => {
  const rawPhoneNumber = phoneNumber && phoneNumber.replace(/\-/g, '').replace(/\+/g, '');
  if (rawPhoneNumber && (rawPhoneNumber.length < 7 || rawPhoneNumber.length > 15)) {
    return rawPhoneNumber.length < 7 ? 'shortPhoneNumber' : 'longPhoneNumber';
  }
  return '';
};

export default checkValidPhoneNumber;